import { Component } from "@angular/core";
import { UiDateHelperService } from "@webapp/ui/date-picker/services/date-helper.service";
import { ɵMonthHeaderComponent as MonthHeaderComponent } from "ng-zorro-antd/date-picker";

@Component({
  selector: "ui-month-header",
  exportAs: "uiMonthHeader",
  templateUrl: "../date-header/date-header.component.html",
})
export class UiMonthHeaderComponent extends MonthHeaderComponent {
  constructor(dateHelper: UiDateHelperService) {
    super(dateHelper);
  }
}
